import {
  Input,
  Output,
  OnInit,
  OnChanges,
  ViewChild,
  Component,
  EventEmitter,
  SimpleChanges,
} from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { CoreComponent } from '@app/core/core.component';

@Component({
  selector: 'sociuu-drawer',
  templateUrl: './sociuu-drawer.component.html',
  styleUrls: ['./sociuu-drawer.component.scss'],
})

export class SociuuDrawer extends CoreComponent implements OnInit, OnChanges {
  @ViewChild('drawer') drawer: MatDrawer;
  @Output() save: EventEmitter<void> = new EventEmitter<void>();
  @Output() close: EventEmitter<void> = new EventEmitter<void>();
  @Output() edit: EventEmitter<void> = new EventEmitter<void>();


  @Input() customClasses: string = '';
  @Input() customContainerClass: string = 'drawer-wrapper';

  @Input() _state: boolean = true;
  @Input() hasBackdrop: boolean = true;
  @Input() mode: 'side' | 'over' | 'push' = 'over';
  @Input() position: 'start' | 'end' = 'end';
  @Input() disableClose: boolean = true;
  @Input() renderActionMenuAt: 'top' | 'bottom' = 'bottom';
  @Input() title: string;
  @Input() disableSaveBtn: boolean = false;
  @Input() edittingEnabled: boolean = false;
  @Input() disableAutoClose: boolean = false;
  @Input() public shouldHideSaveButton: boolean = false;

  public get isOpen(): boolean {
    return this._state;
  }

  public set setState(val: boolean) {
    this._state = val;
    if (val === true) this.drawer.open();
    if (val === false) this.drawer.close();
  }

  public toggleDrawer(): void {
    if (this._state === true) {
      this.drawer.close().then(e => {
        this._state = false;
        this.close.emit();
      })
    } else {
      this._state = true;
      this.drawer.toggle();
    }
  }

  constructor() {
    super();
  }

  ngOnInit() { }

  ngOnChanges(changes: SimpleChanges): void {
  }

  public onBackdropClicked(): void {

  }

  public handleSave(): void {
    this.save.emit();
  }

  public handleClose(): void {
    this.toggleDrawer();
  }

  public handleEdit(): void {
    this.edit.emit();
  }
}
